import { FC } from "react";
import { Platform } from "react-native";
import * as RadioGroupPrimitive from "@rn-primitives/radio-group";

import { cn } from "@/utils/tailwind";

export const BaseRadioGroup: FC<RadioGroupPrimitive.RootProps> = ({
  className,
  ...props
}) => {
  return (
    <RadioGroupPrimitive.Root className={cn("gap-3", className)} {...props} />
  );
};

export const BaseRadioGroupItem: FC<RadioGroupPrimitive.ItemProps> = ({
  className,
  ...props
}) => {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        "dark:bg-input/30 border-sidebar aspect-square size-4 shrink-0 items-center justify-center rounded-full border shadow-sm shadow-black/5",
        Platform.select({
          web: "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive outline-none transition-all focus-visible:ring-[3px] disabled:cursor-not-allowed",
        }),
        props.disabled && "opacity-50",
        className,
      )}
      {...props}>
      <RadioGroupPrimitive.Indicator className="bg-sidebar size-3 rounded-full" />
    </RadioGroupPrimitive.Item>
  );
};
